import React, { useContext, useState, useEffect } from "react";
import RangeSelector from "../components/RangeSelector";
import ReportFilter from "../components/ReportFilter";
import "chartjs-adapter-moment";
import {
    Chart as ChartJS,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    BarElement,
    TimeScale,
} from "chart.js";
import { Line, Bar } from "react-chartjs-2";
import { longDateString, msFromUnix, unixFromMs } from "../utils";
import moment from "moment";
import StarekContext from "../context/StarekContext";
import { getRawData } from "../services/RepositoryService";
import { generateSubIntervals } from "../utils";
import _ from "lodash";

ChartJS.register(
    TimeScale,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,
    Title,
    Tooltip,
    Legend
);
const OnOffReport = () => {
    const context = useContext(StarekContext);
    const [graphs, setGraphs] = useState([]);
    const [rawData, setRawData] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                setRawData(await getRawData(context.activePlant.id));
            } catch (error) {
                context.showErrorMessage(error.message);
            }
        })();
    }, []);

    useEffect(() => {
        if (!rawData) {
            return;
        }
        const epochs = generateSubIntervals(
            moment(rawData?.from),
            moment(rawData?.to).add(10, "hours"),
            "minutes",
            60
        );
        console.log("epochs", epochs);
        const graphs = rawData?.devices?.map((device) => {
            return (
                <>
                    <div className="row">
                        <div className="col-3">
                            <input type="checkbox" />
                            {device?.name}
                            <br />
                            {device?.description}
                            <br />
                            {device?.device_id}
                            <br />
                            {device?.model}
                            <br />
                        </div>
                        <div className="col-9">
                            <Line
                                options={{
                                    responsive: true,
                                    plugins: {
                                        legend: {
                                            position: "top",
                                        },
                                        title: {
                                            display: true,
                                            text: device?.name,
                                        },
                                        tooltip: {
                                            callbacks: {
                                                label: function(context) {
                                                    return `${context.dataset.label || ''} ${(context.parsed.y /1023 * 100).toFixed(2)}%`;
                                                }
                                            }
                                        }
                                    },
                                    scales: {
                                        y: {
                                            type: "linear",
                                            title: {
                                                display: true,
                                                text: "On / Off",
                                            },
                                            display: true,
                                            position: "left",
                                            ticks: {
                                                display: false,
                                            },
                                            max: 1024,
                                            min: 0,
                                        },
                                        y1: {
                                            type: "linear",
                                            display: true,
                                            position: "right",
                                            grid: {
                                                drawOnChartArea: false,
                                            },
                                            max: 100,
                                            min: 0,
                                            ticks: {
                                                callback: function (
                                                    label,
                                                    index,
                                                    labels
                                                ) {
                                                    return label + "%";
                                                },
                                            },
                                        },
                                        x: {
                                            type: "time",
                                            ticks: {
                                                source: "auto",
                                                callback: (m) => {
                                                    return m;
                                                },
                                            },
                                        },
                                    },
                                }}
                                data={{
                                    datasets: device?.signals
                                        ?.filter((signal) => signal.type !== 0 && !signal.is_reported_auxillary)
                                        .map((signal) => {
                                            console.log(signal.name, signal?.style);
                                            return {
                                                ...(!signal?.is_analog && { stepped: "before" }),
                                                label: signal?.name,
                                                data: signal?.data.map(
                                                    (datum) => {
                                                        return {
                                                            x: datum.epoch,
                                                            y: datum.channel_value,
                                                        };
                                                    }
                                                ),
                                                fill: true,
                                                backgroundColor:
                                                    "#ffffff",
                                                borderColor:
                                                    signal?.style?.color || "#000000",
                                                yAxisID: "y",
                                            };
                                        }),
                                }}
                            />
                        </div>
                    </div>
                </>
            );
        });
        console.log("rawData", rawData);
        console.log("graphs", graphs);
        console.log("from", moment(rawData?.from).utc().toISOString());
        console.log("to", moment(rawData?.to).utc().toISOString());
        setGraphs(graphs);
    }, [rawData]);
    return (
        <section className="content">
            <div className="row">
                <div className="col-xl-12 col-lg-12">
                    <ReportFilter></ReportFilter>
                </div>
            </div>
            <div className="row">
                <div className="col-xl-12 col-lg-12">
                    <div className="card border shadow border-white">
                        <div className="card-body">
                            <div>
                                <div
                                    className="row col-lg-12 d-flex flex-row mr-4 p-2 justify-content-center align-items-center align-items-center"
                                    id="productiondata"
                                >
                                    <RangeSelector
                                        start={msFromUnix(
                                            moment(
                                                "2021-12-31T00:00:00Z"
                                            ).unix()
                                        )}
                                        end={msFromUnix(
                                            moment(
                                                "2022-01-31T00:00:00Z"
                                            ).unix()
                                        )}
                                        steps={4}
                                        prettify={longDateString}
                                    ></RangeSelector>
                                </div>
                                <>{graphs}</>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export { OnOffReport };
